// extracted by mini-css-extract-plugin
export var arrowContainer = "contact-module--arrowContainer--oqTOx";
export var blue = "contact-module--blue--t5ldv";
export var contactLabel = "contact-module--contactLabel--31Zfp";
export var h2 = "contact-module--h2--LPctx";
export var sectionContact = "contact-module--sectionContact--mgrPS";